import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFetch(url, { skip = false } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!skip && !!url);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!url || skip) return;
    setLoading(true);
    setError(null);
    try {
      const r = await api.get(url);
      setData(r.data);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [url, skip]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, setData, loading, error, reload: load };
}
